import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { ImageWithPlaceholder } from '@/components/image-with-placeholder'

export type RedeemOptionChipProps = {
  name: string
  icon?: string | null
  imgWrapperClassName?: string
  className?: string
}

export const RedeemOptionChip = ({
  name,
  icon,
  imgWrapperClassName,
  className,
}: RedeemOptionChipProps) => {
  return (
    <div className="flex items-center justify-center">
      <div
        className={cn(
          // eslint-disable-next-line better-tailwindcss/enforce-shorthand-classes -- explicit px/py so callers overriding only py don't drop px via tailwind-merge
          'mx-auto flex items-center gap-2 rounded-[32px] bg-primary-main/10 px-2.5 py-2.5',
          className,
        )}
      >
        <div className={cn('flex size-6 items-center justify-center', imgWrapperClassName)}>
          <ImageWithPlaceholder
            alt={name}
            placeholderWrapperClassName="p-0"
            src={icon ?? ''}
          />
        </div>
        {Boolean(name) && (
          <Typography
            className="leading-[1]"
            color="primary"
            variant="body3"
          >
            {name}
          </Typography>
        )}
      </div>
    </div>
  )
}
